import { ContentHubData } from "@app/types/ServerCustomContext";
import { configSingleStory } from "@pub/config";
import placeholders from "@pub/placeholders";
import { BreadCrumbs, ResponsiveImage } from "@sphtech/dmg-design-system";
import cx from "classnames";
import { useState } from "react";

import { carouselDownIcon, carouselUpIcon } from "../icons/commonIcons";
import styles from "./fadingcarousel.module.css";

type Props = {
  data?: Omit<ContentHubData, "metaData">;
};

const FadingCarousel = ({ data }: Props) => {
  const [stageIndex, setStageIndex] = useState(0);

  if (
    !data?.contentHubList?.teasers ||
    data.contentHubList.teasers.length === 0
  ) {
    return null;
  }

  const contentListData = data.contentHubList;

  return (
    <div className={styles.fadingCarousel}>
      <a className={styles.titleContainer} href={contentListData.titleUrl}>
        <h2 className={styles.title}>{contentListData.title}</h2>
      </a>

      {contentListData.teasers.map((item, index) => {
        const mobileImage = item.image?.crops.portrait || placeholders.portrait;
        const mobileUpImage =
          item.image?.crops.original || placeholders.landscape;

        return (
          <div
            key={index}
            className={cx(
              styles.carouselBackground,
              index === stageIndex && styles.visible,
            )}
          >
            <ResponsiveImage
              {...mobileImage}
              fill="cover"
              fillAspectRatio={9 / 16}
              mobileUp={{
                ...mobileUpImage,
                fill: "contain",
                fillAspectRatio: 16 / 9,
              }}
            />

            <div className={styles.carouselContent}>
              <div className={styles.quoteAndToc}>
                {item.pullQuote && (
                  <div className={styles.quoteContainer}>
                    <img src={configSingleStory.quote?.svg} alt="quote top" />
                    <p className={styles.quote}>{item.pullQuote.quote}</p>
                    <img
                      className={styles.svgBtm}
                      src={configSingleStory.quote?.svgBtm}
                      alt="quote bottom"
                    />
                  </div>
                )}

                {item.tableOfContents && (
                  <div className={styles.tocContainer}>
                    <h3 className={styles.tocHeader}>
                      {item.tableOfContents.header}
                    </h3>
                    <ol className={styles.tocList}>
                      {item.tableOfContents.items.map((el, index) => (
                        <li key={index}>
                          <a href={`${item.path}#${el.anchor}`}>{el.text}</a>
                        </li>
                      ))}
                    </ol>
                  </div>
                )}
              </div>

              <div className={styles.teaserAndArrows}>
                <div className={styles.teaserContainer}>
                  <BreadCrumbs sections={item.sections} />
                  <a href={item.path}>
                    <h3 className={styles.teaserTitle}>{item.title}</h3>
                  </a>

                  <p className={styles.teaserDesc}>{item.description}</p>
                </div>

                <div className={styles.arrowsContainer}>
                  <button
                    onClick={() => {
                      setStageIndex(stageIndex - 1);
                    }}
                    disabled={stageIndex === 0}
                    className={styles.arrow}
                  >
                    {carouselUpIcon}
                  </button>
                  <button
                    onClick={() => {
                      setStageIndex(stageIndex + 1);
                    }}
                    disabled={stageIndex === contentListData.teasers.length - 1}
                    className={styles.arrow}
                  >
                    {carouselDownIcon}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FadingCarousel;
